import { nodeListToArray } from './nodeListToArray';

export function disableTabbableChildren(parent) {
    let tabbableChildren = nodeListToArray(parent.querySelectorAll('a, button, input, select, textarea'));
    tabbableChildren.forEach(child => {
        child.tabIndex = -1;
    })
}